import fetchJson from 'app/core/api/fetch-json'

export const createNewAIJuniorProject = ({ ...opts }, options = {}) =>
  fetchJson('/db/ai_junior_project', _.assign({}, options, {
    method: 'POST',
    json: { ...opts },
  }))

export const processAIJuniorProject = ({ projectHandle, ...opts }, options = {}) =>
  fetchJson(`/db/ai_junior_project/${encodeURIComponent(projectHandle)}/process`, _.assign({}, options, {
    method: 'POST',
    json: { ...opts },
  }))

export const getAIJuniorProjects = (options = {}) => fetchJson('/db/ai_junior_project', options)

export const getAIJuniorProject = ({ projectHandle }, options = {}) => fetchJson(`/db/ai_junior_project/${encodeURIComponent(projectHandle)}`, options)

export const getAIJuniorProjectsForScenarioAndUser = ({ scenarioHandle, userId }, options = {}) => fetchJson(`/db/ai_junior_project?scenarioHandle=${encodeURIComponent(scenarioHandle)}&userId=${encodeURIComponent(userId)}&sort=-1`, options)

// shared: 'none' | 'result' | 'full'
export const shareAIJuniorProject = ({ projectHandle, shared }, options = {}) =>
  fetchJson(`/db/ai_junior_project/${encodeURIComponent(projectHandle)}/share`, _.assign({}, options, {
    method: 'POST',
    json: { shared },
  }))

// Public — works with no session, which is the whole point of a share link.
export const getSharedAIJuniorProject = ({ projectHandle }, options = {}) =>
  fetchJson(`/db/ai_junior_project/${encodeURIComponent(projectHandle)}/shared`, options)
